import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import EmptyState from "@/components/EmptyState";
import { CardSkeleton } from "@/components/Skeletons";
import { Button } from "@/components/ui/button";
import { Plus, ClipboardList } from "lucide-react";

export default function Estimates() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/estimates");
      setItems(data);
    })();
  }, []);

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-3xl font-bold">Estimates</h1>
        <Link to="/estimates/new" data-testid="new-estimate-btn">
          <Button className="h-12 px-4 bg-blue-600 hover:bg-blue-700 font-semibold rounded-xl">
            <Plus className="w-5 h-5 mr-1.5" />
            <span className="hidden sm:inline">New Estimate</span>
            <span className="sm:hidden">New</span>
          </Button>
        </Link>
      </div>

      {/* Workflow visual */}
      <div className="bg-white rounded-2xl border border-slate-200 p-4 overflow-x-auto">
        <div className="flex items-center gap-2 min-w-max text-sm font-semibold">
          <span className="px-3 py-1.5 rounded-full bg-blue-100 text-blue-800">1. Estimate</span>
          <span className="text-slate-400">→</span>
          <span className="px-3 py-1.5 rounded-full bg-orange-100 text-orange-800">2. Job</span>
          <span className="text-slate-400">→</span>
          <span className="px-3 py-1.5 rounded-full bg-slate-100 text-slate-700">3. Invoice</span>
          <span className="text-slate-400">→</span>
          <span className="px-3 py-1.5 rounded-full bg-green-100 text-green-800">4. Payment</span>
        </div>
      </div>

      {items === null ? (
        <CardSkeleton count={3} />
      ) : items.length === 0 ? (
        <EmptyState
          icon={ClipboardList}
          title="No estimates yet"
          description="Send your first plumbing estimate to win the job."
          action={
            <Link to="/estimates/new">
              <Button className="h-12 px-5 bg-blue-600 hover:bg-blue-700 font-semibold rounded-xl">
                <Plus className="w-5 h-5 mr-1.5" /> Create estimate
              </Button>
            </Link>
          }
        />
      ) : (
        <div className="space-y-2">
          {items.map((e) => (
            <Link key={e.id} to={`/estimates/${e.id}`} data-testid={`estimate-row-${e.id}`}>
              <div className="bg-white rounded-2xl border border-slate-200 p-4 hover:border-blue-300 hover:shadow-sm transition-all active:scale-[0.99] mb-2">
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-slate-900 truncate">{e.number} — {e.title}</div>
                    <div className="text-sm text-slate-500 mt-0.5">{e.customer_name}</div>
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0">
                    <div className="font-bold text-lg" style={{ fontFamily: "Outfit" }}>
                      ${(e.total_amount || 0).toFixed(2)}
                    </div>
                    <StatusBadge status={e.status} />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
